import React, { useCallback, useRef } from 'react';
import { useAvailableSpace, } from '../../../utils/hooks/useAvailableSpace';
var MeasuredStage = function (_a) {
    var prevLoadDims = _a.prevLoadDims, updateCookie = _a.onUpdatedDims, _b = _a.shouldUpdateCookie, shouldUpdateCookie = _b === void 0 ? true : _b, children = _a.children;
    var ref = useRef(null);
    var onResize = useCallback(function (_a) {
        var contentSize = _a.contentSize;
        if (contentSize && shouldUpdateCookie && updateCookie) {
            updateCookie(contentSize); // only the contentSize is important to save
        }
    }, [shouldUpdateCookie, updateCookie]);
    var sizes = useAvailableSpace(ref, onResize, { contentSize: prevLoadDims });
    return React.createElement("div", { ref: ref }, children(sizes));
};
export default MeasuredStage;
//# sourceMappingURL=MeasuredStage.js.map